class CodigoPostal
{
	id = null;
    codigo_postal = null;

    constructor(obj) {    
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];
  	}
}

export default CodigoPostal;